import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import './slider.css'
import './Team.css'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            
            style={{ display: "none"}}
            onClick={onClick}
        />
    );
}
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className}`}
            style={{ display: "none" }}
            onClick={onClick}
        />
    );
}

const OurTeams = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const teams = [
        {
            img: "https://images.unsplash.com/photo-1493863641943-9b68992a8d07?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=739&q=80",
            name: "Tauhid Khan",
            title: "Trainer"
        },
        {
            img: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=731&q=80",
            name: "Tarik Khan",
            title: "Graphics Designer"
        },
        {
            img: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
            name: "Muhammad Jayed",
            title: "Web Developer"
        },
        {
            img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
            name: "Upcomming Person",
            title: "Super Technology"
        }
    ]
    return (
        <div className='bg-color w-full'>
            <div className='bg-color lg:py-16 py-11 px-5 xl:px-0 max-w-6xl mx-auto'>
            <div class="">
                <h1 class="text-3xl font-semibold text-center text-gray-800 capitalize lg:text-4xl dark:text-white">
               Our Top Rating <span class="text-blue-500 ">Instructors</span>
                </h1>

                <p class="max-w-2xl mx-auto mt-6 text-center text-gray-500 dark:text-gray-300 hidden md:block">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo incidunt ex placeat modi magni quia error
                    alias, adipisci rem similique, at omnis eligendi optio eos harum.
                </p>

                <p class="max-w-2xl mx-auto mt-6 text-center text-gray-500 dark:text-gray-300 md:hidden">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo incidunt ex 
                </p>
                <div>
                    <Slider {...settings}>
                        {
                            teams.map(team =>
                                <div className='group bg-white info-card p-2 duration-300 ease-in-out shadow-xl rounded border'>
                                <div className='w-full h-56 relative overflow-hidden bg-no-repeat bg-cover rounded-xl'>
                                    <img class="w-full h-56 rounded-xl group-hover:scale-110 transition duration-300ease-in-out  " src={team.img} alt="" />
                                    <div className="w-full px-5 absolute bottom-3 cursor-pointer">
                                        <div className="w-full z-50 py-4  transition-opacity duration-700 opacity-0 group-hover:opacity-100 bg-blue-500">
                                            <div className='flex items-center gap-5 justify-center  text-xl text-white'>
                                                <i class="fa-brands fa-facebook"></i>
                                                <i class="fa-brands fa-whatsapp"></i>
                                                <i class="fa-brands fa-linkedin-in"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex items-center justify-between flex-col'>
                                    <h1 class="mt-4 text-2xl font-semibold text-gray-700 capitalize dark:text-white">{team.name}</h1>

                                    <p class="mt-2 text-gray-500 capitalize dark:text-gray-300">{team.title}</p>
                                </div>
                            </div>
                            )

                        }
                    </Slider>
                </div>
            </div>
        </div>
        </div>
    );
};

export default OurTeams;